import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/apps", label: "Games", testid: "nav-apps-link" },
  { to: "/#books", label: "Books", testid: "nav-books-link", hash: true },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const renderLink = (l, mobile = false) => {
    const base = mobile
      ? "px-4 py-3 rounded-2xl font-bold transition-colors"
      : "px-4 py-2 rounded-full font-bold text-sm transition-colors duration-200";
    if (l.hash) {
      return (
        <Link
          key={l.to}
          to={l.to}
          data-testid={l.testid}
          onClick={() => setOpen(false)}
          className={`${base} text-ink/70 hover:text-ink hover:bg-ink/5`}
        >
          {l.label}
        </Link>
      );
    }
    return (
      <NavLink
        key={l.to}
        to={l.to}
        data-testid={l.testid}
        onClick={() => setOpen(false)}
        className={({ isActive }) =>
          `${base} ${isActive ? "bg-sun text-ink" : "text-ink/70 hover:text-ink hover:bg-ink/5"}`
        }
      >
        {l.label}
      </NavLink>
    );
  };

  return (
    <header className="sticky top-3 sm:top-4 z-50 px-3 sm:px-6">
      <nav className="mx-auto max-w-6xl rounded-full border-2 border-ink bg-cream/90 backdrop-blur-md px-4 sm:px-6 py-2.5 shadow-brutal-sm flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" aria-label="KITOE entertainment home">
          <Logo size={38} />
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => renderLink(l))}
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="ml-2 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-ink text-cream font-bold text-sm border-2 border-ink hover:bg-coral transition-colors duration-200"
          >
            <Lock size={14} /> Admin
          </Link>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 rounded-full border-2 border-ink bg-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden mx-auto max-w-6xl mt-2 rounded-3xl border-2 border-ink bg-white shadow-brutal p-3 flex flex-col gap-1"
        >
          {links.map((l) => renderLink(l, true))}
          <NavLink
            to="/admin"
            onClick={() => setOpen(false)}
            className="px-4 py-3 rounded-2xl font-bold bg-ink text-cream inline-flex items-center gap-2"
          >
            <Lock size={14} /> Admin
          </NavLink>
        </div>
      )}
    </header>
  );
};
